import axios from "axios";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_API_URL;
export class HttpClient {
  constructor(baseURL) {
    this.instance = axios.create({
      baseURL,
    });
    this._initializeResponseInterceptor();
  }

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError
    );
  };

  _handleResponse = (data) => data;

  _handleError = async ({ response }) => {
    if (response?.status === 401) {
      Cookies.remove("para-admin_ufo");
      Cookies.remove("paraAdmin_auth_token");
      window.location.href = "/auth/login";
    }

    return Promise.resolve(response);
  };
}

export default HttpClient;
